import { render } from "./gruas.vue?vue&type=template&id=5d73afa4"
import script from "./gruas.vue?vue&type=script&lang=js"
export * from "./gruas.vue?vue&type=script&lang=js"
script.render = render

export default script